import fc from "@/firebaseConfig";
import firebase from "firebase/app";
// import algoliasearch from "algoliasearch";
import getDocumentTypeKey from "../../libs/getDocumentTypeKey";
import router from "@/router";
import gql from "graphql-tag";
import moment from "moment";
const _ = require("lodash");


const removeDuplicatesWithSameId = (inputArray) => {
  const idSet = new Set(); // To track encountered IDs
  const resultArray = [];

  for (const item of inputArray) {
    // Assuming each item has an 'id' property
    const itemId = item.objectID;

    if (!idSet.has(itemId)) {
      // If the ID is not in the set, add it to the result and the set
      idSet.add(itemId);
      resultArray.push(item);
    }
  }

  return resultArray;
}

const sortByField = (arr, field, order) => {
  const multiplier = order === "desc" ? -1 : 1;
  const compareFunction = (a, b) => {
    const aValue = a[field];
    const bValue = b[field];

    if (typeof aValue === "string" && typeof bValue === "string") {
      return multiplier * aValue.localeCompare(bValue);
    }

    return multiplier * (aValue - bValue);
  };

  return [...arr].sort(compareFunction);
};

function isNumeric(input) {
  return /^[0-9]+$/.test(input);
}

// Almost every column here is a LITERAL top-level Firestore key that happens to
// contain dots ("SCTT.AHTA.BTP.ID"), which is exactly what a one-segment
// FieldPath means — that is why `new FieldPath(searchField)` has always worked.
// `@DocData` is the one real nested map, so its subfields need two segments;
// passing "@DocData.policyNo" as a single segment would look for a top-level
// key spelled with a dot and silently match nothing.
const DOC_DATA_PREFIX = "@DocData.";

const toFieldPath = (field) => {
  if (typeof field === "string" && field.indexOf(DOC_DATA_PREFIX) === 0) {
    return new firebase.firestore.FieldPath(
      "@DocData",
      field.slice(DOC_DATA_PREFIX.length)
    );
  }
  return new firebase.firestore.FieldPath(field);
};

// Fields whose values are stored as strings even when they look like a number.
// Coercing "26070001" to 26070001 turns a prefix search into an exact match
// against a type the document does not have, so it finds nothing.
const STRING_SEARCH_FIELDS = [
  "@BuyerBranchID",
  "SCTT.AHTA.BTP.ID",
  "SCTT.AHTA.BTP.STR.ID",
  "objectID",
  "@DocData.policyNo",
];

function adjustDate(inputDateString) {
  const inputDate = new Date(inputDateString);
  const localOffset = inputDate.getTimezoneOffset() * 60000;
  const adjustedInputDate = new Date(inputDate.getTime() - localOffset);
  const dateStr = adjustedInputDate.toISOString();
  return dateStr;
}

function removeDuplicatesAndEmptyStrings(arr) {
  // Use a Set to store unique values
  const uniqueValues = new Set();

  // Use the filter method to iterate through the array
  const filteredArray = arr.filter((item) => {
    if (item === '') {
      // Exclude empty strings
      return false;
    } else if (!uniqueValues.has(item)) {
      // Include non-empty values not seen before
      uniqueValues.add(item);
      return true;
    }
    return false; // Exclude duplicates
  });

  return filteredArray;
}

const getFormatedKeywordList = (_keyword, _prefixes) => {
  _prefixes = removeDuplicatesAndEmptyStrings(_prefixes)
  // console.log("_prefixes formated ==> ", _prefixes)
  _keyword = _keyword.toUpperCase();
  let _formatedKeywordList = [
    _keyword,
    ...(_prefixes.some((prefix) => _keyword.startsWith(prefix))
      ? ""
      : _prefixes.map((prefix) => prefix + _keyword)),
  ];

  // console.log("_formatedKeywordList:: ", _formatedKeywordList)
  return _formatedKeywordList;
};

function getDateBefore(inputDateString) {
  const millisecondsBefore = 12 * 60 * 60 * 1000; // One day in milliseconds
  const inputDate = new Date(inputDateString);
  const adjustedDate = new Date(inputDate.getTime() - millisecondsBefore);
  const dateStr = adjustedDate.toISOString();
  return dateStr;
}

export default {
  namespaced: true,
  state: {
    list: [],
    listOrigin: [],
    searchField: "objectID",
    page: 1,
    loading: false,
    count: 0,
    keyword: "",
    fromDate: "",
    toDate: "",
    emptyList: true,
    // จำนวนใบที่กำแพงโควต้าคัดออกตอนโหลดหน้าล่าสุด — ใช้บอกผู้ใช้ให้ถูกว่าหน้าที่ว่าง
    // เป็นเพราะเอกสารถูกซ่อน ไม่ใช่เพราะไม่มีเอกสาร
    hiddenByQuota: 0,
    stackPage: {},
    currentPageAlgolia: 0,
    docList: [],
    orderBySelect: { key: "ED.IssueDateTime", value: "desc" },
    valueFilterList: ["@DownloadedXml", "not-download", "cancelled"],
    selectedList: [],
    summaryAll: null,
    showPaginationTemplate: true,
    mDocsDocListUnsubscribeObject: null,
    mDocsSummaryAllUnsubscribeObject: null,
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
    setFromDate(state, val) {
      state.fromDate = val;
    },
    setToDate(state, val) {
      state.toDate = val;
    },
    setSearchField(state, val) {
      state.searchField = val;
    },
    setCompaniesDocs(state, val) {
      state.list = val;
    },
    setPage(state, val) {
      state.page = val;
    },
    setKeyword(state, val) {
      state.keyword = val;
    },
    setListOrigin(state, val) {
      state.listOrigin = val;
    },
    setEmptyList(state, val) {
      state.emptyList = val;
    },
    setHiddenByQuota(state, val) {
      state.hiddenByQuota = val;
    },
    setStackPage(state, val) {
      state.stackPage = val;
    },
    setCurrentPageAlgolia(state, val) {
      state.currentPageAlgolia = val;
    },
    setDocList(state, val) {
      state.docList = val;
    },
    setOrderBySelect(state, val) {
      state.orderBySelect = val;
    },
    setValueFilterList(state, val) {
      state.valueFilterList = val;
    },
    setSelectedList(state, val) {
      state.selectedList = val;
    },
    setSummaryAll(state, val) {
      state.summaryAll = val;
    },
    setShowPaginationTemplate(state, val) {
      state.showPaginationTemplate = val;
    },
  },
  actions: {
    updateDocs({ commit }, val) {
      commit("setCompaniesDocs", val);
    },
    getDocumentType() {
      let documentType = router.currentRoute.name.split(".");
      // console.log("documentType:::::::: ", documentType)

      if (documentType.length > 2) {
        return documentType[documentType.length - 1];
      }

      return "";
    },
    setLoading({ commit }, val) {
      commit("setLoading", val);
    },
    setFromDate({ commit }, val) {
      commit("setFromDate", val);
    },
    setToDate({ commit }, val) {
      commit("setToDate", val);
    },
    setSearchField({ commit }, val) {
      commit("setSearchField", val);
    },
    async setDocsData({ commit }, data) {
      if (data && data.length) {
        let pageLimit = localStorage.getItem("pageLimit");
        if (pageLimit === "auto") {
          pageLimit = parseInt(localStorage.getItem("pageLimitAuto")) || 10;
        } else {
          pageLimit = parseInt(pageLimit) || 10;
        }

        let docsList = data;
        let docs = [];
        for (let doc of docsList) {
          doc = doc.node;
          let timeSignedXml = null;
          if (doc.timeSignedXml) {
            timeSignedXml = moment(doc.timeSignedXml);
          }
          //update condition
          var gSchemeID = "";
          if (doc.buyerTaxID.length == 13 && doc.buyerBranchID.length == 5) {
            gSchemeID = "TXID";
          }
          if (doc.buyerTaxID.length == 13 && doc.buyerBranchID == "") {
            gSchemeID = "NIDN";
          }
          if (
            (doc.buyerTaxID == "" || doc.buyerTaxID == "N/A") &&
            doc.buyerBranchID == ""
          ) {
            gSchemeID = "OTHR";
          }

          let d = {
            "@BuyerBranchID": doc.buyerBranchId,
            "@DocType": doc.docType,
            "@DownloadedXml": doc.downloadedXml,
            "ED.IssueDateTime": doc.edIssueDateTime,
            "@Errors": JSON.parse(JSON.parse(doc.errors)),
            "@MailSent": doc.mailSent,
            objectID: doc.objectId,
            "SCTT.AHTA.BTP.ID": doc.scttAhtaBtpId,
            //add new
            "SCTT.AHTA.BTP.STR.schemeID": gSchemeID,
            //add new
            "SCTT.AHTA.BTP.Name": doc.scttAhtaBtpName,
            "SCTT.AHTA.BTP.STR.ID": doc.scttAhtaBtpStrId,
            "SCTT.AHTS.STSHMS.GrandTotalAmount":
              doc.scttAhtsStshmsGrandTotalAmount,
            "SCTT.AHTS.STSHMS.TaxBasisTotalAmount":
              doc.scttAhtsStshmsTaxBasisTotalAmount,
            "SCTT.AHTS.STSHMS.TaxTotalAmount": doc.scttAhtsStshmsTaxTotalAmount,
            "@SignedPdfUrl": doc.signedPdfUrl,
            "@SignedXmlUrl": doc.signedXmlUrl,
            "@TimeSignedXml": timeSignedXml,
            "@UnsignedPdfUrl": doc.unsignedPdfUrl,
            id: doc.objectId,
            "@BuyerEmail": doc.buyerEmail,
          };
          docs.push(d);
        }
        let startVisible = docs[0];
        let lastVisible = docs[docs.length - 1];

        let objectTmp = Object.freeze({
          first: startVisible,
          last: lastVisible,
        });
        let stackPage = Object.assign({}, this.state.docs.stackPage);
        stackPage[this.state.docs.page] = objectTmp;

        commit("setStackPage", stackPage);
        commit("setCompaniesDocs", docs);
        commit("setListOrigin", docs);
        commit("setEmptyList", false);
        commit("setLoading", false);
      } else {
        commit("setCompaniesDocs", []);
        commit("setListOrigin", []);
        commit("setEmptyList", true);
      }
    },
    async getList({rootState, commit, dispatch}, {id, isNextPage}) {
      commit("setLoading", true);
      // ตัวนับของคิวรี่ก่อนหน้าต้องตายตรงนี้ ไม่งั้นเส้นทางที่ return ก่อนถึง listener
      // (ค้นหา/ช่วงวันที่) จะปล่อยให้หน้าว่างโชว์จำนวนของคิวรี่คนละชุด
      commit("setHiddenByQuota", 0);

      const pageLimitForKeyword = 4000;

      // console.log("fromDate ==> ", this.state.docs.fromDate);
      // console.log("toDate ==> ", this.state.docs.toDate);

      // console.log("HIII GETLIST TRIGGER::");

      let pageLimit = localStorage.getItem("pageLimit");
      if (pageLimit === "auto") {
        pageLimit = parseInt(localStorage.getItem("pageLimitAuto")) || 10;
      } else {
        pageLimit = parseInt(pageLimit) || 10;
      }


      let documentType = await dispatch("getDocumentType");
      let documentTypeNumber = getDocumentTypeKey(documentType);
      let selectedBranch = rootState.companies.selectedBranch;

      // บริษัทที่ใช้ "นำเข้าข้อมูล CSV" (isEtaxType 4) ห้ามเห็นเอกสารที่ถูกยกเลิก
      // ปนอยู่ในหน้าเอกสารการขายรวม (parent list ที่ไม่ได้กรอง @DocType) — ยังคงเห็นได้ปกติที่แท็บ "ใบแจ้งยกเลิก"
      let selectedProductList = rootState.companies.selectedCompanyProductList;
      let isCsvImportCompany = !!(
        selectedProductList &&
        selectedProductList.isEtax &&
        selectedProductList.isEtaxType === 4
      );
      let isParentDocumentList = !documentTypeNumber;

      let downloaded =
        this.state.docs.valueFilterList.includes("@DownloadedXml");
      let cancelled = this.state.docs.valueFilterList.includes("cancelled");
      let notDownload =
        this.state.docs.valueFilterList.includes("not-download");
      let docCancelled = cancelled && !notDownload && !downloaded;

      // console.log("KEYWORD TRIGGERED!!");

      let query = fc.companies.doc(id).collection("Docs");
      let {keyword} = this.state.docs;

      let combinedResults = [];

      if (selectedBranch) {
        query = query.where("@SellerBranchID", "==", selectedBranch);
      }

      if (documentTypeNumber) {
        query = query.where("@DocType", "==", documentTypeNumber);
      }

      // let countItem = 0;

      if (keyword) {
        const _searchField = toFieldPath(this.state.docs.searchField);

        // console.log("keyword type ==> ", typeof(keyword))
        // console.log("_searchField ==> ", this.state.docs.searchField)

        var cleanKeyword = keyword
          .replace(/[,.]/g, "")
          .replace(/\s/g, "")
          .trim();

        let _keyword;
        let _endKey;

        if (
          isNumeric(cleanKeyword) &&
          STRING_SEARCH_FIELDS.indexOf(this.state.docs.searchField) === -1
        ) {
          _keyword = Number(cleanKeyword);
          _endKey = _keyword;
          // console.log("keyword type number ==> ", typeof(_keyword))
          // console.log("keyword type number ==> ", _keyword)
        } else {
          _keyword =
            this.state.docs.searchField == "objectID"
              ? keyword.trim().toUpperCase()
              : keyword.trim();
          _endKey = _keyword + "\uf8ff";
          // console.log("keyword type string ==> ", typeof(_keyword))
        }

        // console.log("_keyword::: ", _keyword);
        // console.log("_endKey::: ", _endKey);
        // console.log("typeof(_keyword)::: ", typeof _keyword);

        // if(this.state.docs.searchField == "objectID"){

        // }
        let summaryAll = this.state.docs.summaryAll
        let prefixes = []
        // console.log("documentType ", documentType);
        // console.log("summaryAll prefixes ==> ", summaryAll?.prefixes);
        switch (documentType.toLowerCase()) {
          case "ab":
            prefixes = summaryAll?.prefixes?.ab ? summaryAll?.prefixes?.ab : []
            break;
          case "cr":
            prefixes = summaryAll?.prefixes?.cr ? summaryAll?.prefixes?.cr : []
            break;
          case "dr":
            prefixes = summaryAll?.prefixes?.dr ? summaryAll?.prefixes?.dr : []
            break;
          case "re":
            prefixes = summaryAll?.prefixes?.re ? summaryAll?.prefixes?.re : []
            break;
          case "rt":
            prefixes = summaryAll?.prefixes?.rt ? summaryAll?.prefixes?.rt : []
            break;
          case "tx":
            prefixes = summaryAll?.prefixes?.tx ? summaryAll?.prefixes?.tx : []
            break;
          default:
            prefixes = summaryAll?.prefixes ? Object.values(summaryAll?.prefixes)?.reduce((acc, value) => acc?.concat(value), []) : [];
            // console.log("prefixes ========= ", prefixes)
            break;
        }
        const searhKeyList = getFormatedKeywordList(_keyword, prefixes);

        // console.log("searchKeylist:: ", searhKeyList);

        // Use a for loop to search for results for each keyword in searchKeyList
        for (const keyword of searhKeyList) {
          // Append "\uf8ff" to the keyword to use it as the end key
          const endKey = `${keyword}\uf8ff`;

          // Create a new query for each keyword
          const keywordQuery = query
            .where(_searchField, ">=", keyword)
            .where(_searchField, "<=", endKey)
            .limit(pageLimitForKeyword);

          // Execute the query and push the results into the combinedResults array
          const results = await keywordQuery.get(); // Assuming you are using an async database query method

          // Combine results
          results.forEach((doc) => {
            if (doc.exists) {
              const data = doc.data();
              const _id = doc.id;
              combinedResults.push({...data, id: _id});
            }
          });
        }

        // console.log("combinedResults:: ", combinedResults);

        if (isCsvImportCompany && isParentDocumentList && !docCancelled) {
          combinedResults = combinedResults.filter(
            (item) => item?.["@DocData"]?.docStatus !== "C"
          );
        }

        query = query
          .where(_searchField, ">=", _keyword)
          .where(_searchField, "<=", _endKey)
          .limit(pageLimitForKeyword);
      }

      if (this.state.docs.fromDate) {
        const _searchField = toFieldPath(this.state.docs.searchField);

        const _keyword = getDateBefore(this.state.docs.fromDate);

        if (this.state.docs.toDate) {
          const _endKey = adjustDate(this.state.docs.toDate);
          // console.log("dateKeyFrom::: ", _keyword);
          // console.log("dateKeyTo::: ", _endKey);
          query = query
            .where(_searchField, ">=", _keyword)
            .where(_searchField, "<=", _endKey)
            .limit(pageLimitForKeyword);
        } else {
          const _endKey = adjustDate(this.state.docs.fromDate);
          // console.log("dateKeyFrom::: ", _keyword);
          query = query
            .where(_searchField, ">=", _keyword)
            .where(_searchField, "<=", _endKey)
            .limit(pageLimitForKeyword);
        }

        // console.log("date triggered");
      }


      if (
        this.state.docs.orderBySelect &&
        this.state.docs.orderBySelect["key"] &&
        this.state.docs.orderBySelect["key"] !== "ID" &&
        !keyword &&
        !this.state.docs.fromDate &&
        !this.state.docs.toDate
      ) {
        const orderKey = this.state.docs.orderBySelect["key"];

        // เอกสารที่ยังไม่ได้เซ็น (3,228 ใบ) เก็บ @TimeSignedXml เป็น null และ Firestore
        // เรียง null ไว้หน้าสุดเสมอ กดลูกศรขึ้นจึงเจอแต่ช่องว่าง "-" เต็มหน้าแทนที่จะ
        // เป็นใบที่เซ็นเก่าที่สุด — ตัดใบที่ไม่มีเวลาเซ็นออกเฉพาะตอนเรียงด้วยคอลัมน์นี้
        //
        // ไม่เรียงด้วยคอลัมน์นี้ (ลูกศรสองทาง) ใบพวกนั้นกลับมาอยู่ในรายการตามปกติ
        if (orderKey === "@TimeSignedXml") {
          query = query.where(toFieldPath(orderKey), "!=", null);
        }

        query = query.orderBy(
          toFieldPath(orderKey),
          this.state.docs.orderBySelect["value"]
        );
      }


      if (
        this.state.docs.valueFilterList.length > 0 &&
        (!keyword || (!this.state.docs.fromDate && !this.state.docs.toDate))
      ) {
        if (downloaded && !notDownload) {
          query = query.where("@DownloadedXml", "==", true);
        }
        if (notDownload && !downloaded) {
          query = query.where("@DownloadedXml", "==", false)
        }

        if (docCancelled) {
          query = query.where("@DocData.docStatus", "==", "C");
        }


      }


      //if page is more than 1 means when nextPage click
      if (this.state.docs.page > 1 && (!keyword || (!this.state.docs.fromDate && !this.state.docs.toDate))) {
        let listTmpPage;
        if (isNextPage) {
          //if page press next
          listTmpPage = this.state.docs.stackPage[this.state.docs.page - 1];
          query = query.startAfter(listTmpPage["last"]).limit(pageLimit);
        } else {
          //if press previous
          listTmpPage = this.state.docs.stackPage[this.state.docs.page];
          query = query.startAt(listTmpPage["first"]).limit(pageLimit);
        }
      } else if (pageLimit) {
        query =
          keyword
            ? query.limit(pageLimitForKeyword)
            : query.limit(pageLimit);
      }

      // โทเคนของ "คิวรี่ชุดนี้" ต้องตั้งตรงนี้ — ก่อนทางลัดของโหมดค้นหาที่ return ออกไป
      // ด้านล่าง ไม่งั้นพอผู้ใช้พิมพ์ค้นหา โทเคนจะยังเป็นของชุดก่อนหน้า ลูปที่ค้างอยู่
      // เทียบแล้วตรง เลยคอมมิตทับผลการค้นหา
      const queryToken = {};
      this.state.mDocsListQueryToken = queryToken;

      if (this.state.mDocsDocListUnsubscribeObject) {
        this.state.mDocsDocListUnsubscribeObject();
      }


      if (combinedResults.length > 0) {

        // console.log("Combine so cool")
        //If there is filter downloaded xml
        const {valueFilterList, orderBySelect} = this.state.docs;
        const downloaded = valueFilterList.includes("@DownloadedXml");
        const notDownload = valueFilterList.includes("not-download");

        if (
          downloaded &&
          !notDownload &&
          (keyword || (this.state.docs.fromDate && this.state.docs.toDate))
        ) {
          combinedResults = this.state.docs.list.filter(
            (item) => item["@DownloadedXml"]
          );
        } else if (
          notDownload &&
          !downloaded &&
          (keyword || (this.state.docs.fromDate && this.state.docs.toDate))
        ) {
          combinedResults = this.state.docs.list.filter(
            (item) => !item["@DownloadedXml"]
          );
        }

        if (
          orderBySelect &&
          orderBySelect.key &&
          orderBySelect.key !== "ID" &&
          (keyword || this.state.docs.fromDate || this.state.docs.toDate)
        ) {
          // console.log("sort local")
          const {key, value} = orderBySelect;
          combinedResults = sortByField(combinedResults, key, value);
        }

        // console.log("documentsArray:: ", documentsArray.length);

        if (
          this.state.docs.page > 1 &&
          (keyword || this.state.docs.fromDate || this.state.docs.toDate)
        ) {
          // console.log("listOrigin :: ,", documentsArray);
          const {key, value} = orderBySelect;
          commit(
            "setCompaniesDocs",
            sortByField(
              [...this.state.docs.list, ...combinedResults],
              key,
              value
            )
          );

          // console.log("COMPANY LIST DOC::::::::: ", this.state.docs.list)

        } else {
          commit("setCompaniesDocs", combinedResults);
        }
        commit("setCompaniesDocs", combinedResults.slice(0, 10));
        commit("setListOrigin", combinedResults);
        // ผลการค้นหาไม่ได้ผ่าน keepSnap — ใบที่เกินโควต้าหลุดมาถึงตารางแล้วถูก
        // visibleDocs คัดออกตอนวาด หน้าจึงว่างได้ทั้งที่ค้นเจอ ต้องนับจากของที่คอมมิตจริง
        commit(
          "setHiddenByQuota",
          (this.state.docs.list || []).filter((d) => d["@OverQuota"] === true)
            .length
        );
        commit("setEmptyList", false);
        commit("setLoading", false);
        return
      }

      // เอกสารที่ถูกกำแพงโควต้าซ่อน (@OverQuota) และเอกสารยกเลิกของบริษัทนำเข้า CSV
      // ถูกคัดออกหลังดึงมาแล้ว ไม่ใช่ตอนคิวรี่ — Firestore กรอง "ใบที่ไม่เกินโควต้า"
      // ไม่ได้ เพราะใบที่ไม่เกินไม่มีฟิลด์ @OverQuota ให้เทียบ
      // อ่านเฉพาะฟิลด์ที่ต้องใช้ตัดสิน — snap.data() ถอดรหัสเอกสารทั้งใบใหม่ทุกครั้ง
      // (ไม่ได้ cache) การไล่อ่านหลักพันใบจึงเสียเวลาไปกับการถอดรหัสของที่ทิ้งทันที
      // คืนเหตุผลที่ซ่อน ไม่ใช่แค่จริง/เท็จ — ข้อความบนหน้าว่างพูดถึงโควต้าอย่างเดียว
      // ถ้านับเอกสารยกเลิกของบริษัทนำเข้า CSV รวมไปด้วย ผู้ใช้จะถูกบอกให้ไปจ่าย
      // ค่าส่วนเกินที่ไม่มีอยู่จริง
      const hideReason = (snap) => {
        if (snap.get("@OverQuota") === true) {
          return "quota";
        }
        if (isCsvImportCompany && isParentDocumentList && !docCancelled) {
          const docStatus = snap.get(
            new firebase.firestore.FieldPath("@DocData", "docStatus")
          );
          if (docStatus === "C") {
            return "cancelled";
          }
        }
        return null;
      };

      // listener ตัวนี้ยิงอีเวนต์ทุกครั้งที่เอกสารในหน้าต่างเปลี่ยน และบัญชีที่ pusher
      // ยิงเอกสารเข้ามาตลอดจะยิงถี่มาก การไล่อ่านเป็น async จึงต้องมีลำดับกำกับ:
      // อีเวนต์ใหม่ที่เริ่มทีหลังถือเป็นเจ้าของผลลัพธ์ รอบเก่าต้อง "หยุดอ่านทันที"
      // ไม่ใช่แค่ไม่คอมมิต — ไม่งั้นลูปของทุกอีเวนต์จะซ้อนกันจนหน้าค้าง
      let listenerSeq = 0;


      this.state.mDocsDocListUnsubscribeObject = combinedResults.length === 0 && query.onSnapshot(
        async (documents) => {
          const mySeq = ++listenerSeq;
          let documentsArray = [];
          // console.log("documents.size der:::: ", documents.size);
          if (documents.size !== 0) {
            // ใบที่ถูกซ่อนมากองติดกันได้ทั้งก้อน (เดือนที่เกินโควต้าถูกเซ็นทีหลัง
            // พอเรียงตามเวลาเซ็นจึงขึ้นมาอยู่หน้าแรกหมด) ถ้าตัดทิ้งเฉย ๆ หน้าจะว่าง
            // ทั้งที่ยังมีเอกสารอีกเป็นหมื่น — ดึงต่อจากใบสุดท้ายไปเรื่อย ๆ จนได้ครบหน้า
            let hiddenQuotaCount = 0;
            const keepAndCount = (snap) => {
              const reason = hideReason(snap);
              if (reason === "quota") {
                hiddenQuotaCount += 1;
              }
              return reason === null;
            };
            let kept = documents.docs.filter(keepAndCount);
            let lastConsumed = documents.docs[documents.docs.length - 1];
            let scanned = documents.size;

            if (kept.length < pageLimit && documents.size >= pageLimit) {
              // ขนาดก้อนเริ่มเล็กแล้วค่อยโตเป็นเท่าตัว เอกสารที่นี่ใบใหญ่ (มีรายการสินค้า
              // อยู่ข้างใน) เวลาที่เสียไปจึงอยู่ที่ปริมาณข้อมูลมากกว่าจำนวนรอบ — วัดจริง
              // บนบัญชีที่มีใบซ่อน: 200 ใบใช้ 2.0 วินาที แต่ 2,000 ใบใช้ 16.5 วินาที
              // และโดยปกติไล่ไม่ถึง 150 ใบก็ได้ครบหน้าแล้ว ก้อนใหญ่จึงเป็นการจ่ายเปล่า
              let topUpBatch = 200;
              // เพดานกันกรณีผิดปกติ ไม่ให้ไล่อ่านทั้งคอลเลกชัน
              const MAX_SCAN = 6000;
              // และเพดานเวลา: บัญชีที่ใบถูกซ่อนกองหนามาก ๆ ต่อให้ยังไม่ถึง MAX_SCAN
              // ก็ไม่ควรให้ผู้ใช้นั่งรอเกินนี้ ยอมแสดงหน้าที่ไม่เต็มดีกว่าค้าง
              const DEADLINE = Date.now() + 8000;
              while (
                kept.length < pageLimit &&
                scanned < MAX_SCAN &&
                Date.now() < DEADLINE &&
                lastConsumed
              ) {
                // มีอีเวนต์ใหม่ หรือผู้ใช้เปลี่ยนไปคิวรี่ชุดอื่นแล้ว — เลิกอ่านทันที
                if (mySeq !== listenerSeq || this.state.mDocsListQueryToken !== queryToken) {
                  return;
                }
                const more = await query
                  .startAfter(lastConsumed)
                  .limit(topUpBatch)
                  .get();
                if (more.size === 0) {
                  break;
                }
                scanned += more.size;
                for (const snap of more.docs) {
                  lastConsumed = snap;
                  if (keepAndCount(snap)) {
                    kept.push(snap);
                    if (kept.length >= pageLimit) {
                      break;
                    }
                  }
                }
                if (more.size < topUpBatch) {
                  break;
                }
                // ยังไม่ครบ แปลว่าใบที่ซ่อนกองหนากว่าที่คิด ขยายก้อนเพื่อไม่ให้ยิงหลายรอบ
                topUpBatch = Math.min(topUpBatch * 2, 1000);
              }
            }

            // มีอีเวนต์ใหม่ หรือย้ายไปคิวรี่ชุดอื่นแล้ว — ทิ้งผลรอบนี้ อย่าคอมมิตทับของใหม่
            if (mySeq !== listenerSeq || this.state.mDocsListQueryToken !== queryToken) {
              return;
            }

            kept = kept.slice(0, pageLimit);

            // ห้าม freeze เอกสารที่ส่งเข้า state — หน้าเอกสารแก้ค่าในแถวตรง ๆ อยู่
            // (table.vue: $set(doc, "@DocData", next) ตอนบันทึกหมายเหตุ Lao eTax)
            // ถ้า freeze จะโยน TypeError ใน strict mode แล้วไปโผล่เป็น "บันทึกไม่สำเร็จ"
            // ทั้งที่เขียน Firestore สำเร็จแล้ว
            //
            // ลอง freeze เฉพาะรายการสินค้าแล้ววัดดู ไม่ช่วยให้เร็วขึ้นเลย (ยัง ~190ms
            // เท่าเดิม) จึงไม่เก็บไว้ ส่วนที่ทำให้เร็วขึ้นจริงคือการเลิก cloneDeep
            // ของ snapshot ด้านล่าง ซึ่งลดจาก 2,466ms เหลือระดับนี้
            for (const doc of kept) {
              let document = doc.data();
              document.id = doc.id;
              documentsArray.push(document);
            }

            // เคอร์เซอร์ของหน้าถัดไปต้องเป็นใบสุดท้ายที่ "อ่านถึง" ไม่ใช่ใบสุดท้ายที่ "เก็บไว้"
            // ถ้าหยุดกลางคัน (ชนเพดานเวลา/จำนวน) แล้วใช้ใบที่เก็บไว้ หน้าถัดไปจะวนอ่าน
            // ก้อนที่ถูกซ่อนก้อนเดิมซ้ำแล้วไปไม่ถึงไหน
            // ส่วน first คือ "ต้นหน้าต่างของหน้านี้" ใช้ตอนกดย้อนกลับ (startAt)
            // ถ้าหน้าถูกซ่อนทั้งหน้าแล้วไปหยิบ lastConsumed มาใส่ กดย้อนกลับมาหน้านี้
            // จะได้เนื้อหาของหน้าถัดไปแทน ต้องเป็นใบแรกของหน้าต่างเสมอ
            let startVisible =
              kept.length > 0 ? kept[0] : documents.docs[0] || lastConsumed;
            let lastVisible = lastConsumed || kept[kept.length - 1];

            // ห้าม cloneDeep ของพวกนี้ — startVisible/lastVisible เป็น DocumentSnapshot
            // ที่ข้างในอ้างถึงตัว Firestore SDK ทั้งก้อน การโคลนลึกจึงไล่เดินกราฟมหาศาล
            // (วัดจากเบราว์เซอร์: บล็อกเมนเธรดรวดเดียว 1.8 วินาทีตอนสลับแท็บ) และ
            // cloneDeep(stackPage) ยังโคลนของทุกหน้าที่เคยเก็บไว้ซ้ำทุกครั้งอีก
            //
            // snapshot ใช้เป็นเคอร์เซอร์อย่างเดียว ไม่มีใครแก้ค่า เก็บตัวอ้างอิงไปตรง ๆ ได้
            // freeze ไว้เพื่อไม่ให้ Vue ไล่ทำ reactivity ให้ทั้งกราฟ
            let objectTmp = Object.freeze({
              first: startVisible,
              last: lastVisible,
            });
            let stackPage = Object.assign({}, this.state.docs.stackPage);
            stackPage[this.state.docs.page] = objectTmp;

            //If there is filter downloaded xml
            const {valueFilterList, orderBySelect} = this.state.docs;
            const downloaded = valueFilterList.includes("@DownloadedXml");
            const notDownload = valueFilterList.includes("not-download");

            if (
              downloaded &&
              !notDownload &&
              (keyword || (this.state.docs.fromDate && this.state.docs.toDate))
            ) {
              documentsArray = this.state.docs.list.filter(
                (item) => item["@DownloadedXml"]
              );
            } else if (
              notDownload &&
              !downloaded &&
              (keyword || (this.state.docs.fromDate && this.state.docs.toDate))
            ) {
              documentsArray = this.state.docs.list.filter(
                (item) => !item["@DownloadedXml"]
              );
            } else if (
              docCancelled &&
              (keyword || (this.state.docs.fromDate && this.state.docs.toDate))
            ) {
              documentsArray = this.state.docs.list.filter(
                (item) => item['@DocData']['docStatus'] == 'C'
              );
            }

            if (
              orderBySelect &&
              orderBySelect.key &&
              orderBySelect.key !== "ID" &&
              (keyword || this.state.docs.fromDate)
            ) {
              const {key, value} = orderBySelect;
              documentsArray = sortByField(documentsArray, key, value);
            }

            // console.log("documentsArray:: ", documentsArray.length);

            commit("setStackPage", stackPage);
            if (
              this.state.docs.page > 1 &&
              (keyword || this.state.docs.fromDate || docCancelled)
            ) {
              // console.log("listOrigin :: ,", documentsArray);
              const {key, value} = orderBySelect;
              commit(
                "setCompaniesDocs",
                sortByField(
                  [...this.state.docs.list, ...documentsArray],
                  key,
                  value
                )
              );
              // console.log("Yeeee")
            } else {
              // console.log("Yooo")
              commit("setCompaniesDocs", removeDuplicatesWithSameId(documentsArray));
            }
            // console.log("documentsArrayDer ==> ", documentsArray);
            // console.log("documentsArrayDerFormat ==> ", removeDuplicatesWithSameId(documentsArray).map((item)=> item.objectID));
            commit("setListOrigin", documentsArray);
            commit("setHiddenByQuota", hiddenQuotaCount);
            commit("setEmptyList", false);
          } else if (
            documents.size === 0 &&
            (keyword || this.state.docs.fromDate || this.state.docs.toDate) &&
            this.state.docs.page > 1
          ) {
            commit("setCompaniesDocs", removeDuplicatesWithSameId(this.state.docs.list));
            commit("setListOrigin", []);
            commit("setHiddenByQuota", 0);
          } else {
            commit("setCompaniesDocs", []);
            commit("setListOrigin", []);
            commit("setHiddenByQuota", 0);
            commit("setEmptyList", true);
          }
          commit("setLoading", false);
        }
      );

    },
    getDocListUnsubscribe() {
      if (this.state.mDocsDocListUnsubscribeObject) {
        this.state.mDocsDocListUnsubscribeObject();
        this.state.mDocsDocListUnsubscribeObject = null;
      }
      // ลูปไล่อ่านที่อาจค้างอยู่ต้องตายไปพร้อมกัน ไม่ใช่วิ่งต่อหลังออกจากหน้าไปแล้ว
      this.state.mDocsListQueryToken = null;
    },
    getListByMonth(
      { commit },
      { companyID, startDate, endDate, reportBranchType }
    ) {
      commit("setLoading", true);
      const fieldQuery = new firebase.firestore.FieldPath(
        "ED.IssueDateTime.Timestamp"
      );
      const docs = fc.companies.doc(companyID).collection("Docs");
      let query = docs;

      query = query.where("@DownloadedXml", "==", true);

      if (startDate && endDate) {
        query = query
          .where(fieldQuery, ">=", new Date(startDate))
          .where(fieldQuery, "<=", new Date(endDate));
      }

      if (reportBranchType) {
        query = query.where("@SellerBranchID", "==", reportBranchType);
      }

      query.get().then(function (docs) {
        let docList = [];

        docs.forEach((doc) => {
          let docData = doc.data();
          docData.id = doc.id;

          // case 4 ใบลดหนี้ - Credit Memo
          if (docData["@DocType"] === 4) {
            docData["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"] *= -1;
            docData["SCTT.AHTS.STSHMS.TaxTotalAmount"] *= -1;
            docData["SCTT.AHTS.STSHMS.GrandTotalAmount"] *= -1;
          }

          // freeze ก่อนเข้า state: Vue 2 จะข้ามการทำ deep reactivity ให้ทั้งใบ
          // (เอกสารหลักพันใบใช้เวลาเดินทุก key นานเป็นวินาที และรายงานอ่านอย่างเดียว)
          docList.push(Object.freeze(docData));
        });

        commit("setDocList", docList);
        commit("setLoading", false);
      });
    },
    updatePage({ commit }, { page }) {
      commit("setPage", page);
    },
    updateKeyword({ commit }, { keyword }) {
      // commit("setCurrentPageAlgolia", 0);
      commit("setKeyword", keyword);
    },
    resetKeyword({ commit }) {
      commit("setKeyword", "");
    },
    setOrderBySelect({ commit }, { orderBySelect }) {
      // console.log("orderBySelect::: ", orderBySelect);
      commit("setOrderBySelect", orderBySelect);
    },
    setValueFilterList({ commit }, { valueFilterList }) {
      commit("setValueFilterList", valueFilterList);
    },
    setSelectedList({ commit }, { selectedList }) {
      commit("setSelectedList", selectedList);
    },
    // The customer's own note on one Lao eTax document. Stored at
    // `@DocData.remark` and nowhere else: it is not the gateway's "remarks"
    // field (that is ED.IN.Subject, which the Lao mapper files and the Lao PDFs
    // print) and it is never sent anywhere — the same contract @DocData.policyNo
    // has. See src/libs/laoRemark.js.
    //
    // Written through the store rather than from the component because that is
    // this app's rule for Firestore writes, even though table.vue has older
    // inline batch.update() calls next to the code that calls this.
    //
    // The dotted key is a nested field path, so this replaces only `remark`
    // inside `@DocData` and leaves policyNo / docStatus alone. Deleting the
    // field for an empty note (rather than storing "") keeps a document with no
    // note indistinguishable from one that never had the field.
    async setLaoRemark(_ctx, { companyID, objectID, remark }) {
      const value = (remark || "").toString().trim();
      await fc.companies
        .doc(companyID)
        .collection("Docs")
        .doc(objectID)
        .update({
          "@DocData.remark": value
            ? value
            : firebase.firestore.FieldValue.delete(),
        });
    },
    getSummaryAll({ commit }, { companyId }) {
      if (this.state.mDocsSummaryAllUnsubscribeObject) {
        this.state.mDocsSummaryAllUnsubscribeObject();
      }
      this.state.mDocsSummaryAllUnsubscribeObject = fc.companies
        .doc(companyId)
        .collection("Summaries")
        .doc("all")
        .onSnapshot(function (allSummaries) {
          commit("setSummaryAll", allSummaries.data());
        });
    },
    getSummaryAllUnsubscribe() {
      if (this.state.mDocsSummaryAllUnsubscribeObject) {
        this.state.mDocsSummaryAllUnsubscribeObject();
        this.state.mDocsSummaryAllUnsubscribeObject = null;
      }
    },
    setShowPaginationTemplate({ commit }, { val }) {
      commit("setShowPaginationTemplate", val);
    },
  },
};

export const docsQuery = gql`
  query docs(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $companyId: String!
    $order: String
    $search: String
    $issueDateTimeRange: [DateTime]
    $objectId: String
    $scttAhtaBtpId: String
    $buyerBranchId: String
    $typeLineTotal: String
    $lineTotal: [Float]
    $typeTaxTotal: String
    $taxTotal: [Float]
    $typeGrandTotal: String
    $grandTotal: [Float]
    $timeSignedXmlRange: [DateTime]
    $docType: String
    $downloadedXml: Boolean
    $signSuccess: Boolean
    $hasError: Boolean
    $mailSent: Boolean
    $suspendedAccount: Boolean
    $buyerEmail_Isnull: Boolean
  ) {
    docs: allDocument(
      first: $first
      after: $after
      last: $last
      before: $before
      companyId: $companyId
      order: $order
      search: $search
      issueDateTimeRange: $issueDateTimeRange
      objectId: $objectId
      scttAhtaBtpId: $scttAhtaBtpId
      buyerBranchId: $buyerBranchId
      typeLineTotal: $typeLineTotal
      lineTotal: $lineTotal
      typeTaxTotal: $typeTaxTotal
      taxTotal: $taxTotal
      typeGrandTotal: $typeGrandTotal
      grandTotal: $grandTotal
      timeSignedXmlRange: $timeSignedXmlRange
      docType: $docType
      downloadedXml: $downloadedXml
      signSuccess: $signSuccess
      hasError: $hasError
      mailSent: $mailSent
      suspendedAccount: $suspendedAccount
      buyerEmail_Isnull: $buyerEmail_Isnull
    ) {
      totalCount
      edgeCount
      edges {
        node {
          id
          docType
          objectId
          edIssueDateTime
          scttAhtaBtpId
          scttAhtaBtpName
          scttAhtaBtpStrId
          buyerBranchId
          scttAhtsStshmsTaxBasisTotalAmount
          scttAhtsStshmsTaxTotalAmount
          scttAhtsStshmsGrandTotalAmount
          timeSignedXml
          mailSent
          downloadedXml
          signedXmlUrl
          signedPdfUrl
          unsignedPdfUrl
          errors
          buyerEmail
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
